// extracted by mini-css-extract-plugin
export default {"container":"textarea_container__EfIOe","invalid":"textarea_invalid__SPd92"};